import Backbone from 'backbone';

export default Backbone.Router.extend({
  routes: {
    ':query': function(query) {
      this.view.setFttcById(query);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc1/fttc1Router.js
 **/